import {styled} from '@mui/material';

import {AccordionData} from 'presentation/components';

const ChargeDetailsAccordion = styled(AccordionData)(({theme}) => ({
	marginTop: theme.spacing(3),
	border: `1px solid ${theme.palette.other.divider}`,
	'&::before': {display: 'none'},
}));

export {ChargeDetailsAccordion};
